
import { Component, Vue, Prop } from 'vue-property-decorator';
import { LavorazioneSlim, StatoLavorazione } from '@/models';
import ItemListLavorazione from "./ItemListLavorazione.vue";

@Component({
    components: { ItemListLavorazione }
})
export default class LavorazioniList extends Vue {
    @Prop() private lavorazioni!: LavorazioneSlim[];
    @Prop({ default: false }) private compact!: boolean;
    @Prop({ default: true }) private workflow!: boolean;

    private iconClassByProgress(lav: LavorazioneSlim): string {
        if (lav.progresso == 0) {
            return 'grey';
        } else if (lav.progresso == 100) {
            return 'green';
        }

        return 'amber';
    }
}
